import React from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import WellnessService from "services/WellnessService";

export default ({ onClose, triviaId, teamId }) => {
  const [loading, setLoading] = useState(false);

  const closeSurvey = () => {
    setLoading(true);
    WellnessService.closeActiveTrivia(triviaId, teamId)
      .then(() => {
        setLoading(false);
        onClose(true);
      })
      .catch(() => setLoading(false));
  };
  return (
    <Modal
      center
      closeOnEsc={false}
      closeOnOverlayClick={false}
      styles={{
        modal: {
          maxWidth: "40%",
          width: "40%",
          borderRadius: "10px",
        },
      }}
      open
      onClose={() => onClose(false)}
    >
      <div className="p-3">
        <h5>
          <strong>Are you sure?</strong>
        </h5>
        <h6 className="mt-2">
          You want to close this trivia, as its no longer available for team
          members after that.
        </h6>
        <div className="mt-2 d-flex justify-content-end">
          <button
            disabled={loading}
            onClick={closeSurvey}
            className="btn btn-danger"
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};
